import { MONTH_ABBREVIATIONS } from "./constants";
import moment from "moment/moment";
import _ from "lodash";

function date(val) {
    if (!(this instanceof date)) {
        return new date(val);
    }
    this.val = this.parse(val);
}

date.prototype = {
    parse: function(val) {
        if (_.isNumber(val)) {
            return new Date(val);
        } else {
            return Date.parse(val);
        }
    },

    toMoment: function() {
        return moment(this.val).utc();
    },

    format: function(format) {
        return this.toMoment().format(format);
    },

    isValid: function() {
        return this.toMoment().isValid();
    },

    valueOf: function() {
        return this.toMoment().valueOf();
    }
};

/*
    The function normalizeMonthAbbreviation is designed to replace abbreviated month names
    in a given date string with their full month names.
    This can be useful for standardizing date formats, especially when dealing
    with user input that might include various abbreviations for months.
*/
export const normalizeMonthAbbreviation = dateString => {
    if (!dateString) return dateString;

    let normalizedString = dateString;
    for (const [fullMonth, abbreviations] of Object.entries(MONTH_ABBREVIATIONS)) {
        // Add the full month name to abbreviations to ensure it matches itself
        const allForms = [...abbreviations, fullMonth];
        for (const form of allForms) {
            // Match the month format more flexibly
            const regex = new RegExp(`\\b${form}\\.?\\b`, "gi");
            if (regex.test(normalizedString)) {
                normalizedString = normalizedString.replace(regex, fullMonth);
                // If we found a match, we can break the inner loop
                break;
            }
        }
    }
    return normalizedString;
};

export default date;
